import * as moment from 'moment';
import { IWatrRequest } from '@nkr/models/index';
import { FileDocumentType } from '@nkr/enums/document-type';
import { isHourly, isSelfEmployed } from '../components/utils/employment-type.utils';
import { IWatrSupplementalUploadedDoc } from './watr-supplemental-uploaded-doc';

export type { IWatrSupplementalUploadedDoc } from './watr-supplemental-uploaded-doc';

const REQUEST_FILE_TYPE_PAY_STUB = 1;
const REQUEST_FILE_TYPE_TAX = 2;
const REQUEST_FILE_TYPE_SELF_EMPLOYED = 7;

export const buildWageVerificationSupplementalUploads = (data: IWatrRequest): IWatrSupplementalUploadedDoc[] => {
    const records = data.fileUploadRecords || [];
    const typesPresent = new Set(records.map(r => r.fileType));
    const supplemental: IWatrSupplementalUploadedDoc[] = [];
    const selfEmployed = isSelfEmployed(data.employmentType);

    if (data.taxDocumentFile && selfEmployed && !typesPresent.has(REQUEST_FILE_TYPE_TAX)) {
        supplemental.push({
            key: 'wage-tax',
            fileName: 'Tax return',
            fileTypeDescription: 'Tax Document',
            uploadedDateTime: null,
            sortMoment: moment(0),
            docType: FileDocumentType.Tax
        });
    }

    const hasPayStubOnRequest = data.payStubFile && data.requireSelfEmployedAffirmation == false;
    if (hasPayStubOnRequest && !typesPresent.has(REQUEST_FILE_TYPE_PAY_STUB)) {
        supplemental.push({
            key: 'wage-paystub',
            fileName: 'Pay stub',
            fileTypeDescription: 'Pay Stub',
            uploadedDateTime: null,
            sortMoment: moment(0),
            docType: FileDocumentType.PayStub
        });
    }

    if (data.selfEmployedAffirmationFile && !typesPresent.has(REQUEST_FILE_TYPE_SELF_EMPLOYED)) {
        supplemental.push({
            key: 'wage-se-affidavit',
            fileName: 'Self-employed affidavit',
            fileTypeDescription: 'Self Employed Affirmation',
            uploadedDateTime: null,
            sortMoment: moment(0),
            docType: FileDocumentType.DsSelfEmployedAffidavit
        });
    }

    return supplemental;
};
